// extracted by mini-css-extract-plugin
module.exports = {"map-box":"map-box--3M5xr","container":"container--3-7X0","panel":"panel--155bC","suggestionList":"suggestionList--23Ggk","item_info":"item_info--3enoX","header":"header--3ggBu"};